module.exports = __webpack_public_path__ + "static/olusoji-c82656290da91cab9e880542e80934eb.jpg";